import React from 'react'
import { getImageNameFromUrl, handleDownloadFile } from 'utils/utils'
import Tooltip from '../Tooltip'
import RenderThumbnail from './RenderThumbnail'

const BYTE = 1000
const getKB = (bytes) => Math.round(bytes / BYTE)

const FileItem = (props) => {
    const { file, children } = props
    const { type, name, size, url } = file

    return (
        <div className=" upload-file grid grid-cols-12 gap-2">
            <div className="col-span-2 md:col-span-1 upload-file-thumbnail">
                {/* {renderThumbnail()} */}
                <RenderThumbnail
                    name={name}
                    url={url}
                    type={type}
                    file={file}
                />
            </div>
            <div
                role="button"
                onClick={async () => {
                    await handleDownloadFile(file?.url)
                }}
                className="pl-4 col-span-8 md:col-span-9  upload-file-info flex flex-col"
            >
                <Tooltip
                    customStyle={{
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        maxWidth: '250px',
                    }}
                    title={name || getImageNameFromUrl(url)}
                >
                    <h6 className="upload-file-name w-full truncate">
                        {name || getImageNameFromUrl(url)}
                    </h6>
                </Tooltip>
                {size && (
                    <span className="upload-file-size">{getKB(size)} kb</span>
                )}
            </div>
            <div className="col-span-2 flex items-center justify-end">
                {children}
            </div>
        </div>
    )
}

export default FileItem
